'use strict';

var _ = require('lodash');
var RuleAndStrategyStatementsPrintingService = function RuleAndStrategyStatementsPrintingService(conditionSerializerService, strategyConstants, conditionsFilter, actionPrintingService) {
  var REPLACEMENT_MAP = {
    '=le=': ' <= ',
    '=lt=': ' < ',
    '=ge=': ' >= ',
    '=gt=': ' > ',
    '=in=': ' in ',
    '==': ' = ',
    '=out=': ' not in ',
    ' or ': ' [OR] ',
    '=contains=': ' contains '
  };
  var URD_REGEXP = /legCabin.urd([^)]*)\)/;
  var withoutFlowTypeAppend = true;
  var NL = '\n';
  function createPrintableStatements(result, primaryConditions, linkConditions, rule, strategy) {
    printPrimaryAndLinkCriteria(result, primaryConditions, linkConditions, rule);
    printStrategyStatements(result, rule, strategy);
  }
  function printPrimaryAndLinkCriteria(result, primaryConditions, linkConditions, rule) {
    primaryConditions = getValidConditions(primaryConditions);
    var conditionLevel = rule.primaryCriteriaLevel ? rule.primaryCriteriaLevel.domain : '';
    var serializedPrimaryConditions = conditionSerializerService.serialize(conditionLevel, rule.type, rule.flowType, primaryConditions, withoutFlowTypeAppend);
    serializedPrimaryConditions = appendNewLine(serializedPrimaryConditions);
    linkConditions = getValidConditions(linkConditions);
    var linkConditionLevel = rule.linkCriteriaLevel ? rule.linkCriteriaLevel.domain : '';
    var serializedLinkConditions = conditionSerializerService.serialize(linkConditionLevel, rule.type, rule.flowType, linkConditions, withoutFlowTypeAppend);
    serializedLinkConditions = appendNewLine(serializedLinkConditions);
    var primaryAndLinkConditions = _.concat(primaryConditions, linkConditions);
    var serializedPrimaryAndLinkConditions = [serializedPrimaryConditions, serializedLinkConditions].join(';');
    serializedPrimaryAndLinkConditions = getPrintableConditions(serializedPrimaryAndLinkConditions, primaryAndLinkConditions);
    addConditionsToResult(serializedPrimaryAndLinkConditions, result);
  }
  function printStrategyStatements(result, rule, strategy) {
    var strategyStatements = getStatements(strategy);
    emptyLinesIfNoConditionsBeforeFirstAction(result, strategyStatements);
    _.forEach(strategyStatements, function (statement) {
      var strategyConditions = getValidConditions(statement.conditions);
      var serializedStrategyConditions = conditionSerializerService.serialize(rule.primaryCriteriaLevel ? rule.primaryCriteriaLevel.domain : '', rule.type, rule.flowType, strategyConditions, withoutFlowTypeAppend);
      serializedStrategyConditions = getPrintableConditions(serializedStrategyConditions, strategyConditions);
      addConditionsToResult(serializedStrategyConditions, result);
      addActionsToResult(statement.actions, result, strategy);
      emptyLine(result);
    });
  }
  function getStatements(strategy) {
    if (isClassClosure(strategy) || isAllocationAuthAvail(strategy)) {
      return getStrategyTemplateStatements(strategy);
    }
    if (!strategy.groups) {
      return [];
    }
    var statements = [];
    _.forEach(strategy.groups, function (group) {
      statements.push({
        conditions: group.conditions || [],
        actions: getActions(strategy, group) || []
      });
    });
    return statements;
  }
  function getActions(strategy, group) {
    if (isClassClosure(strategy) || isAllocationAuthAvail(strategy)) {
      return strategy.actionList;
    }
    return group.actions || [];
  }
  function getStrategyTemplateStatements(strategy) {
    return [{
      conditions: strategy.commonConditions,
      actions: strategy.actionList
    }];
  }
  function emptyLinesIfNoConditionsBeforeFirstAction(result, strategyStatements) {
    if (_.isEmpty(result) && !_.isEmpty(strategyStatements) && _.isEmpty(getValidConditions(strategyStatements[0].conditions))) {
      emptyLine(result);
      emptyLine(result);
    }
  }
  function getValidConditions(conditions) {
    var result = conditionsFilter.notEmptyConditions(conditions);
    return _.filter(result, function (strategyCondition) {
      return strategyCondition.category && strategyCondition.criterion;
    });
  }
  function getPrintableConditions(serializedConditions, conditions) {
    _.forEach(conditions, function (condition) {
      serializedConditions = _.replace(serializedConditions, new RegExp(condition.field), condition.category + ' ' + condition.criterion);
      if (condition.category === 'User Def Ref Data') {
        serializedConditions = _.replace(serializedConditions, URD_REGEXP, condition.leftOperand + ' ' + (condition.appendices.urdFunctionType || 'undefined'));
      }
    });
    serializedConditions = _.replace(serializedConditions, new RegExp(_.keys(REPLACEMENT_MAP).join('|'), 'g'), function (matched) {
      return REPLACEMENT_MAP[matched];
    });
    return serializedConditions;
  }
  function addConditionsToResult(conditions, result) {
    _.forEach(conditions.split(';'), function (condition) {
      if (condition !== '') {
        result.push('[AND]');
        result.push(condition + NL);
      }
    });
  }
  function isClassClosure(strategy) {
    return strategy.basis === strategyConstants.StrategyType.CLASS_CLOSURE;
  }
  function isAllocationAuthAvail(strategy) {
    return strategy.basis === strategyConstants.StrategyType.ALLOCATION_AUTH_AVAIL;
  }
  function appendNewLine(serializedConditions) {
    return serializedConditions ? serializedConditions + NL : serializedConditions;
  }
  function addActionsToResult(actions, result, strategy) {
    if (isClassClosure(strategy)) {
      var classClosureActions = [];
      getNonEmptyActions(actions).forEach(function (action) {
        classClosureActions.push(actionPrintingService.printStrategyClosureAction(action));
      });
      if (!_.isEmpty(classClosureActions)) {
        result.push('[THEN]', 'Set authorizationModel to 0\n');
        _.forEach(classClosureActions, function (action) {
          result.push(action);
        });
      }
    } else if (isAllocationAuthAvail(strategy)) {
      var allocationAuthAvailActions = [];
      getNonEmptyActions(actions).forEach(function (action) {
        allocationAuthAvailActions.push(actionPrintingService.printStrategyAllocationAuthAvailAction(action));
      });
      if (!_.isEmpty(allocationAuthAvailActions)) {
        _.forEach(allocationAuthAvailActions, function (action) {
          result.push(action);
        });
      }
    } else {
      getNonEmptyActions(actions).forEach(function (action) {
        result.push('[THEN]');
        result.push(actionPrintingService.printStrategyAction(action));
      });
    }
  }
  function getNonEmptyActions(actions) {
    return _.filter(actions, function (action) {
      return !action.isEmpty();
    });
  }
  function emptyLine(result) {
    result.push(NL);
  }
  return {
    createPrintableStatements: createPrintableStatements
  };
};
RuleAndStrategyStatementsPrintingService.$inject = ['ConditionSerializerService', 'StrategyConstants', 'CriteriaValidateAndFilterService', 'ActionPrintingService'];
module.exports = RuleAndStrategyStatementsPrintingService;